import React, { useEffect, useState } from 'react';
import * as Styled from './BannersStyled';
import LogClick from 'features/shared/ClickStream/Click';
import { BannerItemProps } from './BannerModel';
import { Space } from '@gr-monorepo/common/ui/ui';
import { Link } from 'react-router-dom';

const BannerInner = ({
  id,
  title,
  subtitle,
  button,
  buttons,
  href,
  isCurrent,
  isPrev,
  img,
  onClick,
  animateType,
  logPageEvent,
}: BannerItemProps) => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!show && isCurrent) {
      setShow(true);
      logPageEvent({ eventType: 'show_banner', eventInfo: `banner_${id}` });
    }
  }, [isCurrent]);

  const hrefLink =
    !buttons || (!buttons[0]?.title && !buttons[1]?.title)
      ? href
      : buttons[0]?.title && !buttons[1]?.title
      ? buttons[0]?.link
      : undefined;

  const props =
    hrefLink && !hrefLink?.match(/^http/)
      ? {
          as: Link,
          to: hrefLink,
        }
      : { href: hrefLink, onClick: onClick, target: '_blank' };

  const propsForButton = (url: string) =>
    !url?.match(/^http/)
      ? {
          as: Link,
          to: url,
        }
      : { href: url, target: '_blank' };

  return (
    <LogClick eventType="click_banner" eventInfo={`banner_${id}`}>
      <Styled.Inner
        animate={isPrev ? 'prevFrame' : isCurrent ? animateType : false}
        isCurrent={isCurrent}
        img={img}
        {...(props as any)}
      >
        <Styled.LeftSide>
          <Styled.Title dangerouslySetInnerHTML={{ __html: title }}></Styled.Title>
          <Styled.Subtitle dangerouslySetInnerHTML={{ __html: subtitle }}></Styled.Subtitle>
          <Styled.Space />
          {buttons ? (
            <Styled.Buttons>
              {buttons.map(
                (el) =>
                  el.title && (
                    <>
                      <Styled.Button
                        {...(propsForButton(el.link) as any)}
                        bgColor={el.bgColor}
                        color={el.color}
                        type={el.type || undefined}
                      >
                        {el.title}
                      </Styled.Button>
                      <Space size={24} />
                    </>
                  ),
              )}
            </Styled.Buttons>
          ) : (
            button && <Styled.ButtonOld>{button}</Styled.ButtonOld>
          )}
        </Styled.LeftSide>
        <Styled.RightSide>
          <Styled.Picture></Styled.Picture>
        </Styled.RightSide>
      </Styled.Inner>
    </LogClick>
  );
};

export default BannerInner;
